import React, { useState, useRef } from "react";
import "../../style/home.css";
import Sidebar from "../../components/sidebar";
import { BASE_URL } from "../../utils/config";
import "primeicons/primeicons.css";
import { Toast } from "primereact/toast";
import { Dialog} from '@mui/material';
import iconStockmarket from "../../images/icon-stockmarket-01.png";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import SendIcon from '@mui/icons-material/Send';
import Loading from '../../components/loading';

const SendCommentry = () => {
  const [loading, setLoading] = useState(false);
  const [selectedEventTypes, setSelectedEventTypes] = useState([]);
  const toast = useRef(null);
  const [message, setMessage] = useState("");
  const [fileData, setFileData] = useState(null); 
  const [AlertMessage, setAlertMessage] = useState("");
  const [showAlert, setshowAlert] = useState(false);
  const fileInputRef = useRef(null);

//  this function used to open file manager to select fiel form user's local system
  const openFileManager = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

//   this fucntion is used to select telegram channels
  const handleSelectChange = (event) => {
    const value = event.target.value;
    console.log("value of selected item",value);
    setSelectedEventTypes((prevSelected) => {
      if (prevSelected.includes(value)) {
        // Remove if already selected
        return prevSelected.filter((type) => type !== value);
      } else {
        // Add if not selected
        return [...prevSelected, value];
      }
    });
  }

  // this function is used to change file 
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileData({
        file: file,
        type: file.type,
        name: file.name,
        url: URL.createObjectURL(file),
      });
    }
  };

  //  this function is used to render a file
  const renderFilePreview = () => {
    if (!fileData) return null;

    const { type, url, name } = fileData;

    if (type.startsWith('image/')) {
      // return <img src={url} alt="Selected" style={{ maxWidth: '100%', height: '250px' }} />;
      return <a href={url} download={name}>{name}</a>;
    } else if (type.startsWith('video/')) {
      // return <video controls style={{ maxWidth: '100%', height: '250px' }}><source src={url} type={type} /></video>;
      return <a href={url} download={name}>{name}</a>;
    } else {
      return <a href={url} download={name}>{name}</a>;
    }
  };

//  this function is used to send selected file or message in selected channels
  const handleSendClick = async () => {
    if (selectedEventTypes.length === 0) {
      setAlertMessage("Please Select Channels to send Message.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
      }, 2000);
      return;
    }
    
    if(!fileData && !message){
      setAlertMessage("Please Write Message OR Select File To Send.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
      }, 2000);
      return;
    }
    setLoading(true);

    try {
      const loginuser = JSON.parse(localStorage.getItem("loginData"));

      const formData = new FormData();
      formData.append('channels', JSON.stringify(selectedEventTypes));
      if (message) {
        formData.append('message', message);
      }
      if (fileData) {
        formData.append('file', fileData.file);
      }

      const response = await fetch(`${BASE_URL}/sendMessageToTelegram`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${loginuser.token}`
        },
        body: formData,
      });

      const result = await response.json();
      console.log("send message to telegram result", result);

      setAlertMessage(result.message || "Message Sent to Telegram Successfully.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
      }, 3000);
    } catch (error) {
      console.error('Error sending to Telegram:', error);
      setAlertMessage("Failed to send message to Telegram.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
      }, 3000);
    } finally {
      setLoading(false);
      setMessage("");
      setSelectedEventTypes([]);
      setFileData(null);

    }
  };


  return (
    <div>
      <Sidebar />
      {loading ? (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2,
          }}
        >
          <Loading />
        </div>
      ) : (
        <div className="create-report" style={{padding:'0px',overflow:'auto' ,height:'450px'}}>
          <div className="container">
            <h2 style={{ fontSize: "24px", textAlign: 'center' }}>Send Commentary</h2>
            <Toast ref={toast} position="top-center" />
            <div className="options">
              
               <div className="selectbuttons-sendcommentry">
                {[
                  { label: 'Future', value: 'Future' },
                  { label: 'Options', value: 'Options' },
                  { label: 'Delivery', value: 'Delivery' },
                  { label: 'HNI', value: 'HNI' },
                  { label: 'IntraDay', value: 'IntraDay' },
                  { label: 'Commodity', value: 'Commodity' },
                  { label: 'Free', value: 'Free' },
                  { label: 'NKB', value: 'NKB' },
                  { label: 'F&O', value: 'FO' },
                ].map(({ label, value }) => (
                  <div
                    key={value}
                    className="frame"
                    style={{
                      border: selectedEventTypes.includes(value) ? "2px solid #23499E" : null,
                    }}
                  >
                    <img className="icon" src={iconStockmarket} alt="Icon" />
                    <input
                      type="checkbox"
                      id={value.toLowerCase()}
                      value={value}
                      checked={selectedEventTypes.includes(value)}
                      onChange={handleSelectChange}
                    />
                    <p>{label}</p>
                  </div>
                ))}
              </div>
            </div>
            {fileData && (
                <div className="send-file-preview">
                  <h5>Selected File:</h5>
                  <div className="file-div">
                  {renderFilePreview()}
                  </div>
                </div>
              )}
            <div className="chat-container">
              <div className="input-container">
                <button id="docIcon" className="icon-button" onClick={openFileManager}>
                  <AttachFileIcon style={{ color: '#23589E' }}/>
                </button>
                <input
                  type="file"
                  accept="*/*"
                  style={{ display: 'none' }}
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  id="fileInput"
                  name="file"
                />
                <textarea
                  id="inputField"
                  placeholder="Type a message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
                <button className="send-button" onClick={handleSendClick}>
                  <SendIcon style={{ color: '#23589E' }}/>
                </button>
              </div>
              
            </div>
          </div>
       
        </div>
      )}

        <Dialog
        open={showAlert}
        onClose={() => { setshowAlert(false) }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <p style={{ color: "green", padding: '10px 30px 10px 30px', margin: 0 }}>{AlertMessage}</p>
      </Dialog>
    </div>
  );
};

export default SendCommentry;

